<template>
    <div>
        <Field v-model="content" :field="field" @error="error" v-bind="$attrs" :reduce="reduce" />
    </div>
</template>

<script>
import IdentityFields from '../identityFields/IdentityFields'

export default {
    name: 'Select',
    components: {
        Field: IdentityFields
    },
    props: {
        label: {
            type: String
        },
        value: {
            type: String | Array
        },
        name: {
            type: String
        },
        rules: {
            type: Object,
            default: {}
        },
        items: {
            type: Array,
            default: []
        },
        description: {
            type: String,
        },
        multiple: {
            type: Boolean,
            default: false
        },
        custom: {
            type: Boolean,
            default: false,
        },
        reduce: {
            type: Function,
            default: null
        }
    },
    data: function() {
        return {}
    },
    computed: {
        field() {
            let rules = this.rules

            let items = this.items
            if (this.reduce !== null) {
                items = items.map(this.reduce)
            }

            rules.selectables = {
                items: items,
                multiple: this.multiple,
                custom: this.custom
            }

            return {
                type: "text",
                module: "select",
                key: this.name,
                name: this.label,
                description: this.description,
                constraints: rules
            };
        },
        content: {
            get() {
                let valObj = {}
                valObj[this.field.key] = this.value

                return valObj
            },

            set(val) {
                this.$emit('input', val[this.field.key])
            }
        }
    },
    methods: {
        error(errors) {
            this.$emit('error', errors)
        }
    }
}
</script>